export default __webpack_public_path__ + "static/media/billetera.ad941070.svg";